import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';

import {
  useExteriorSignageQuoteSupportChats,
  usePostExteriorSignageQuoteSupportChat,
  useUpdateSupportChatFiles,
} from 'services/Data/SupportChatServices';
import SupportChatSharedContainer from './SupportChatSharedContainer';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';
import SupportFileUploadModal from './SupportFileUploadModal';

const AssociatedExteriorSignageQuoteSupportChats = ({ disableSupportChat }) => {
  let { exteriorSignageQuoteId } = useParams();

  const { data: supportChats, isFetching: gettingSupportChats } = useExteriorSignageQuoteSupportChats(
    exteriorSignageQuoteId,
  );
  const {
    mutateAsync: postExteriorSignageQuoteSupportChat,
    isPending: isPostingExteriorSignageQuoteSupportChat,
  } = usePostExteriorSignageQuoteSupportChat();

  const { mutateAsync: uploadChatFiles } = useUpdateSupportChatFiles();
  const [files, setFiles] = useState([]);
  const [openUploadModal, setOpenUploadModal] = useState();

  const handleCloseUploadModal = useCallback(() => setOpenUploadModal(false), []);
  const handleOpenUploadModal = useCallback(() => setOpenUploadModal(true), []);
  const handleAddFile = useCallback(files => setFiles(prev => [...prev, ...files]), []);
  const handleResetFile = useCallback(() => setFiles([]), []);

  const handleRemoveFile = useCallback(fileToRemove => setFiles(prev => prev.filter(f => f.path !== fileToRemove.path)), []);

  const handleAddNewNote = useCallback(
    newNote => {
      postExteriorSignageQuoteSupportChat({ note: newNote, exteriorSignageQuote_Id: exteriorSignageQuoteId }).then(
        ({ data: note }) => {
          uploadChatFiles({ files, entityId: note.id, type: BlobStorageTypeEnumValue.SupportChat }).then(_ => {
            handleResetFile();
          });
        },
      );
    },
    [postExteriorSignageQuoteSupportChat, files, uploadChatFiles, handleResetFile, exteriorSignageQuoteId],
  );
  return (
    <>
      <SupportFileUploadModal handleAddFile={handleAddFile} onClose={handleCloseUploadModal} show={openUploadModal} />
      <SupportChatSharedContainer
        fromProfile
        gettingSupportChats={gettingSupportChats}
        supportChats={supportChats}
        handleAddNewNote={handleAddNewNote}
        isPostingSupportChat={isPostingExteriorSignageQuoteSupportChat}
        disableSupportChat={disableSupportChat}
        openUploadFileModal={handleOpenUploadModal}
        files={files}
        handleRemoveFile={handleRemoveFile}
        handleResetFile={handleResetFile}
      />
    </>
  );
};

export default AssociatedExteriorSignageQuoteSupportChats;
